import { render, staticRenderFns } from "./ButtonWithLoading.vue?vue&type=template&id=4becb1fe&"
import script from "./ButtonWithLoading.vue?vue&type=script&lang=js&"
export * from "./ButtonWithLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports